import React from "react";

const defaultValue = {
  clientWizardStep : null,
  setClientWizardStepHandler : (number) => {},
  integrationWizardStep : null,
  setIntegrationWizardStepHandler : (numer) => {},
  loadServerData : (obj) => {},
  getAllSettingsObject :  () => {},
  clientWizardFinished : false,
  setClientWizardFinishedHandler: (bool) => {},
  integrationWizardFinished: false,
  setIntegrationWizardFinishedHandler: (bool) => {},
  integrationJson : null,
  setIntegrationJsonHandler : (object) => {},
  integrationSteps : null,
  setIntegrationStepsHanlder : (arr) => {},
  integrationDocs : null,
  setIntegrationDocsHandler : (arr) => {},
  saveValues : (object) => {},
  integrationData : null,
  setIntegrationDataHandler : (object) => {},
  rowId : null,
  serverDataLoaded : null,
  clearServerData:() => {},
};

export const UserUIStateContext = React.createContext(defaultValue);